<template>
  <section class="lxm-activity-sign-up">
    <div v-if="!hasSignUp" class="not-found-tips">
      <div class="img-wrapper">
        <img src="https://s.lingxi360.com/mobile/img/icon_nothing.png" alt="没有找到">
      </div>
      <p>
        不存在
      </p>
      <p>
        没有相关资料找到哦~
      </p>
    </div>

    <div v-if="isMulSignUp" class="mul-mobile-info">
      共有<span class="count">{{ signUpCount }}</span>个报名
    </div>

    <template v-if="hasSignUp">
      <ul v-for="signUp in signUps" :key="signUp.id" class="lxm-activity-sign-up__table">
      <li v-if="signUp.sessionTimes.length === 1">
        <aside class="sign-cell cell-left"></aside>
        <div class="sign-cell cell-right sign-cell-button-wrapper">
          <sign-in-button
                  :sign-up-id="signUp.id"
                  :number="signUp.signInCode"
                  :activity-config="activityConfig"
                  v-bind:activity-session-time="signUp.sessionTimes[0]"
                  v-on:submit-sign-in="submitSignIn"
                  v-on:submit-sign-out="submitSignout"
                  v-on:cancel-sign-in="cancelSignIn"
          ></sign-in-button>
        </div>
      </li>
      <li>
        <aside class="sign-cell cell-left">报名者：</aside>
        <div class="sign-cell cell-right">
          <span>{{ signUp.name + ' / ' + signUp.mobile }}</span>
        </div>
      </li>
      <li>
        <aside class="sign-cell cell-left">档位：</aside>
        <div class="sign-cell cell-right">
          <ul class="ticket-group">
            <li class="ticket-group-row" v-for="ticket in signUp.tickets" v-bind:key="ticket.key">
              <p class="sign-cell ticket-desc"> {{ ticket.desc }} </p>
              <p class="sign-cell ticket-price">
                <span class="unit-price"> {{ ticket.unit_price }} </span>
                <span class="quantity">{{ ticket.quantity }}</span>
              </p>
            </li>
          </ul>
        </div>
      </li>
      <li v-if="signUp.sessionTimes.length > 1">
        <aside class="sign-cell cell-left">场次：</aside>
        <div class="sign-cell cell-right sign-cell-session-time-wrapper">
          <ul>
            <li v-for="session in signUp.sessionTimes" v-bind:key="session.id" class="sign-cell-session-time-li">
              <span> {{ session.name }} </span>
              <p>
                <sign-in-button
                        :activity-session-time="session"
                        :sign-up-id="signUp.id"
                        :number="signUp.signInCode"
                        :disable-submit="false"
                        :activity-config="activityConfig"
                        @submit-sign-in="submitSignIn"
                        @submit-sign-out="submitSignout"
                        @cancel-sign-in="cancelSignIn"
                />
              </p>
            </li>
          </ul>
        </div>
      </li>
      <li v-if="signUp.adminComment">
        <aside class="sign-cell cell-left">备注: </aside>
        <div class="sign-cell cell-right">
          {{ signUp.adminComment }}
        </div>
      </li>
      <li>
        <aside class="sign-cell cell-left">报名表：</aside>
        <div class="sign-cell cell-right">
          <ul class="form-data-wrapper">
            <li class="form-data-row" v-for="formDatum in signUp.formData" v-bind:key="formDatum.key">
              <p class="form-display"> {{ formDatum.name }} </p>
              <p class="form-value"> {{ formDatum.value }} </p>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </template>
  </section>
</template>

<style lang="stylus" scoped>
@import '../../styles/index.styl'
li
  display table-row
.mul-mobile-info
  margin-bottom 10px
  .count
    color: #ff5348
    font-weight: 800
    font-size: 1.2rem
.lxm-activity-sign-up__table
  position relative
  width: 100%
  padding 1rem
  box-shadow: 0 0 10px 2px grey-white;
  display table
  margin-bottom 5px
  &>li
    height 2rem
    width 100%
    padding 0.4rem 0
  .border-left-style
    width 0
    height 60px
    position absolute
    top 1rem
    left 0
    border-style solid
    border-color grey-white
    border-width 0 0 0 6px
.sign-cell
  display table-cell
  line-height 2rem
  color #000
  font-size 1rem
  font-weight normal
.cell-right
  min-width 4rem
.cell-left
  min-width: 5rem
  color grey-dark
  font-weight 600
.sign-cell-button-wrapper
  text-align right
.sign-cell-session-time-wrapper
  padding-top 1rem
.sign-cell-session-time-li
  display flex
  justify-content space-between
  width 100%
  padding: 5px 0
  border-bottom: 1px dashed #dbdbdb
  p
    // width 12rem
    display inline-block
    text-align right
.ticket-desc
  line-height 1.4rem
.ticket-price
  text-align right
  min-width 5rem
  white-space nowrap
  .unit-price
    &:before
      content '￥'
  color brand-primary
  .quantity
    &:before
      content '*'
.ticket-group-row
  display flex
  justify-content space-between
  overflow hidden
  padding 0.6rem 0
  border-bottom 1px solid grey-white
.not-found-tips
  padding-top 2rem
  .img-wrapper
    width 6rem
    margin 0 auto
    padding-bottom 2rem
    img
      display block
      width 100%
      height 100%
  p
    text-align center
li.feedback-detail
  color #268bd2
  text-decoration underline
  position absolute
  max-width 50%
  left 1rem
.form-data-row
  display block
.form-data-wrapper
  line-height 1.4rem
.form-display
  color grey-dark
  font-weight 600
.form-value
  max-width 17em
  overflow hidden
.form-data-row
  display block
  padding 0.2rem 0

</style>

<script>
// import * as _ from 'lodash'
import * as aTypes from '../../../store/action-types'
import SignInButton from '@/components/Main/Activity/SignInButton'
export default {
  components: {
    'sign-in-button': SignInButton
  },
  props: {
    activityDetail: Object
  },
  data () {
    return {
      disableSubmit: false,
      loading: false
    }
  },
  computed: {
    signUps () {
      return this.$store.state.activity.signUps
    },
    hasSignUp () {
      return this.$store.state.activity.signUpCount > 0
    },
    isMulSignUp () {
      return this.$store.state.activity.signUpCount > 1
    },
    signUpCount () {
      return this.$store.state.activity.signUpCount
    },
    activityConfig () {
      return this.activityDetail && this.activityDetail.config ? this.activityDetail.config : {}
    }
  },
  methods: {
    submitSignIn (sessionTimeId, signUpId, number, signatureFileId = null) {
      const body = {
        'session_time_id': sessionTimeId
      }
      // 如果有签名文件ID，加入请求体
      if (signatureFileId) {
        body.signature_file_id = signatureFileId
      }
      return this.$store.dispatch(aTypes.ACTIVITY_POST_SIGNIN, {
        activityId: this.activityDetail.id,
        signUpId: signUpId,
        body: body
      }).then(() => {
        this.$store.dispatch(aTypes.ACTIVITY_GET_COUNT, {
          activityId: this.activityDetail.id
        })
        this.$store.dispatch(aTypes.ACTIVITY_GET_SIGN_UP, {
          activityId: this.activityDetail.id,
          number: number
        })
      })
    },
    submitSignout (sessionTimeId, signUpId, number) {
      return this.$store.dispatch(aTypes.ACTIVITY_POST_SIGNOUT, {
        activityId: this.activityDetail.id,
        signUpId: signUpId,
        body: {
          'session_time_id': sessionTimeId
        }
      }).then(() => {
        this.$store.dispatch(aTypes.ACTIVITY_GET_COUNT, {
          activityId: this.activityDetail.id
        })
        this.$store.dispatch(aTypes.ACTIVITY_GET_SIGN_UP, {
          activityId: this.activityDetail.id,
          number: number
        })
      })
    },
    cancelSignIn (signInId, signUpId, number) {
      return this.$store.dispatch(aTypes.ACTIVITY_POST_CANCEL_SIGNIN, {
        activityId: this.activityDetail.id,
        signUpId: signUpId,
        signInId
      }).then(() => {
        this.$store.dispatch(aTypes.ACTIVITY_GET_COUNT, {
          activityId: this.activityDetail.id
        })
        this.$store.dispatch(aTypes.ACTIVITY_GET_SIGN_UP, {
          activityId: this.activityDetail.id,
          number: number
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// SignIn.vue?f8c5ebd8